module.exports = __webpack_public_path__ + "static/media/no-image-placeholder.06243037.png";